import React from 'react';

const HomePage = ({ setActiveTab }) => {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            Revolucionamos el mercado inmobiliario con tecnología
          </h1>
          <p className="hero-subtitle">
            Descubre propiedades en Costa Rica con nuestra inteligencia artificial avanzada. 
            Sin filtros complicados, sin búsquedas interminables. Contactanos con lo que buscas
            y nuestra IA te lo encuentra.
          </p>
          <div className="hero-buttons">
            <button 
              className="button-secondary hero-btn"
              onClick={() => setActiveTab('buying')}
            >
              🔍 Explorar Propiedades
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <h2 className="section-title">¿Por qué elegir Link Real Estate?</h2>
        <div className="features-grid">
          <a 
              href="https://linkcapitalsolutions.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="feature-card"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <div className="feature-icon">📄💰</div>
              <h3>Préstamos Puentes</h3>
              <p>
                A través de Link Capital Solutions, te ayudamos a conseguir préstamos puentes 
                para facilitar la compra y venta de las propiedades.
              </p>
            </a>

          <div className="feature-card">
            <div className="feature-icon">🤖</div>
            <h3>Asistente IA Inteligente</h3>
            <p>Nuestro chatbot entiende exactamente lo que buscas y rastrea toda la web para encontrar propiedades perfectas.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">⚡</div>
            <h3>Búsqueda Más Rápida</h3>
            <p>Encuentra propiedades en minutos, no en horas. Nuestra IA procesa miles de listados instantáneamente.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>Precisión Garantizada</h3>
            <p>Menor probabilidad de perder la propiedad perfecta. Nuestra tecnología no deja escapar ningún detalle.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🇨🇷</div>
            <h3>Expertos en Costa Rica</h3>
            <p>Conocimiento profundo del mercado costarricense y todas sus regiones.</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>¿Listo para encontrar tu hogar ideal?</h2>
          <p>Únete a cientos de costarricenses que ya encontraron su propiedad perfecta</p>
          <button 
            className="button-primary cta-btn"
            onClick={() => setActiveTab('contact')}
          >
            Comenzar Búsqueda
          </button>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
